import React, { useState, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Typography } from '@mui/material';
import '../../App.css';
import { Contents } from '../components/Contents';
import { AddContent } from '../components/AddContent';
import AuthorCheck from '../components/AuthorCheck';
import { sessionId } from '../../App';


function FlexBoxes() {
    const [view, setView] = useState('contents'); // Default view for mobile
    const [selectedContent, setSelectedContent] = useState(null); // Manages the selected content for editing
    const [contentsWidth, setContentsWidth] = useState(200); // Initial width for Contents section
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const containerRef = useRef(null);
    const [selectedAuthor, setSelectedAuthor] = useState(null);

    const MIN_CONTENTS_WIDTH = 350; // Minimum width for Contents
    const MIN_ADD_CONTENT_WIDTH = 600; // Minimum width for AddContent

    const handleMouseDown = (e) => {
        e.preventDefault();
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e) => {
        if (containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const newWidth = e.clientX - containerRect.left;
            const maxContentsWidth = containerRect.width - MIN_ADD_CONTENT_WIDTH;

            if (newWidth >= MIN_CONTENTS_WIDTH && newWidth <= maxContentsWidth) {
                setContentsWidth(newWidth);
            }
        }
    };

    const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    const handleSaveContent = (contentData) => {
        if (selectedContent) {
            // Call API to update existing content
            // updateContentAPI(contentData);
        } else {
            // Call API to add new content
            // addContentAPI(contentData);
        }
        setView('contents'); // Return to contents view after saving
    };

    // Handle the author selection callback
    const handleAuthorSelected = (author) => {
        setSelectedAuthor(author);
    };

    return (
        <div
            className="addcontents"
            style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row'
            }}
            ref={containerRef}
        >
            {/* Mobile toggle buttons */}
            {isMobile && (
                <div className="mobile-toggle-buttons" style={{ display: 'flex', justifyContent: 'space-around', padding: '10px' }}>
                    <button onClick={() => setView('contents')}>Contents</button>
                    <button onClick={() => setView('addContent')}>Add Content</button>
                </div>
            )}

            {/* Contents Section */}
            <div
                className="content-section"
                style={{
                    width: isMobile ? '100%' : `${contentsWidth}px`, // Dynamic width based on dragging
                    borderWidth: isMobile ? '0' : '1px', // Remove border when mobile
                    borderStyle: isMobile ? 'none' : 'solid', // Remove border style when mobile
                    borderColor: isMobile ? 'transparent' : theme.palette.primary.main, // Transparent border when mobile
                    padding: isMobile ? '0' : '20px', // Remove padding when mobile
                    margin: isMobile ? '0' : '', // Remove margin when mobile
                    display: isMobile ? (view === 'contents' ? 'block' : 'none') : 'block',
                    minWidth: `${MIN_CONTENTS_WIDTH}px`, // Set minimum width
                }}
            >

                <AuthorCheck sessionId={sessionId} onAuthorSelected={handleAuthorSelected} />

                <Contents
                    setSelectedContent={setSelectedContent}  // Make sure this function is correctly passed
                    setView={setView}  // Ensure this function is also passed correctly
                />

                      {/* Conditionally render author info */}
                {selectedAuthor ? (
                    <Typography variant="body2" color="text.secondary">
                    {`Author(s): ${selectedAuthor.display_name}`}
                    </Typography>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                    Author(s): Unknown
                    </Typography>
                )}

            </div>

            {/* Divider */}
            {!isMobile && (
                <div
                    onMouseDown={handleMouseDown} // Start the dragging
                    style={{
                        width: '5px',
                        cursor: 'col-resize',
                        backgroundColor: theme.palette.primary.light
                    }}
                />
            )}

            {/* AddContent Section */}
            <div
                className="content-section"
                style={{
                    flex: 1, // Take the remaining space
                    borderWidth: isMobile ? '0' : '1px', // Remove border when mobile
                    borderStyle: isMobile ? 'none' : 'solid', // Remove border style when mobile
                    borderColor: isMobile ? 'transparent' : theme.palette.primary.main, // Transparent border when mobile
                    padding: isMobile ? '0' : '20px', // Remove padding when mobile
                    margin: isMobile ? '0' : '', // Remove margin when mobile
                    display: isMobile ? (view === 'addContent' ? 'block' : 'none') : 'block',
                    minWidth: `${MIN_ADD_CONTENT_WIDTH}px`, // Set minimum width
                }}
            >
                <AddContent
                    selectedContent={selectedContent}
                    setView={setView} 
                    onSave={handleSaveContent}
                    onCancel={() => setView('contents')}
                />
            </div>
        </div>
    );
}

export default FlexBoxes;